import { Icon } from "@iconify/react";

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

export const sidebarConfig = [
  {
    title: "Dashboard",
    route: "/dashboard",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "Attorneys ",
    route: "/list-advisors",
    icon: getIcon("entypo:user"),
  },
  {
    title: "Cases",
    route: "/list-cases",
    icon: getIcon("material-symbols:cases"),
  },
  {
    title: "Pools",
    route: "/list-pools",
    icon: getIcon("ic:round-poll"),
  },

  {
    title: "General Setting",
    icon: getIcon("icon-park-solid:setting-web"),
    children: [
      {
        title: "Default Setting",
        route: "/default-settings",
        icon: getIcon("mdi:credit-card-outline"),
      },
    ],
  },
];
